<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/produto&servico"> Cadastro/Produtos e Serviços/Produtos e Serviços </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <div style="position: absolute; right: 0">
        <avatar
          ref="avatar"
          :styleTile="true"
          :title="title"
          :isAllowed="true"
        />
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <formulario
          ref="formulario"
          :grupos="filteredGrupo"
          :subGrupos="filteredSubGrupo"
          :marcas="filteredMarca"
          :unidadesMedida="filteredUndMedia"
          :produtos="filteredProduto"
          :conversoes="conversoes"
          :possuiConversao="possuiConversao"
          :departamentos="departamentos"
        />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="possuiConversao"
            label="Possui Conversão"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addLista()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar lista</span>
          </v-tooltip>
        </v-col>
        <v-col class="text-right">
          <v-btn to="/produto&servico" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-card :disabled="!possuiConversao">
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="conversoes"
        >
          <template v-slot:item.ativo="{ item }">
            {{ item.ativo ? "Ativo" : "Inativo" }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="remove(item.id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Remover conversão</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="750px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Produto / Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div style="position: absolute; right: 0">
              <avatar ref="avatarFrmAdd" :styleTile="true" :title="title" />
            </div>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <formulario
                ref="frmAdd"
                :grupos="filteredGrupo"
                :subGrupos="filteredSubGrupo"
                :marcas="filteredMarca"
                :unidadesMedida="filteredUndMedia"
                :departamentos="departamentos"
              />
            </v-form>
          </v-container> </v-card-text
        ><v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Cancelar
          </v-btn>
          <v-btn color="success" class="mr-4" @click="enviarFrmAdd">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--<Modal
      v-model="showModal"
      modalStyle="max-width: 900px"
      title="Adicionar Produto"
      ><formulario
        ref="frmAdd"
        :grupos="grupos"
        :subGrupos="subGrupos"
        :marcas="marcas"
        :unidadesMedida="unidadesMedida"
      />
      <v-row>
        <v-col align-end>
          <v-btn @click="showModal = false" color="primary" text>
            Cancelar
          </v-btn>
          <v-btn @click="atualizar" color="primary" text> Salvar </v-btn>
        </v-col>
      </v-row>
    </Modal>-->
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { enviarProdutoAsync } from "../../../services/produtoService";
import { mapState, mapActions } from "vuex";
import Formulario from "./Formulario";
import Avatar from "../../Avatar/AvatarCard";

export default {
  name: "criarProduto",
  data: () => ({
    overlay: false,
    valid: true,
    validFrm2: true,
    showModal: false,
    title: "Upload Imagem",
    possuiConversao: false,
    conversoes: [],
    headers: [
      {
        text: "Id",
        align: "start",
        value: "id",
      },
      { text: "Produto", value: "descricao" },
      { text: "Código", value: "codigo" },
      { text: "Und. Med ", value: "unidadeMedida" },
      { text: "Grupo ", value: "grupo" },
      { text: "SubGrupo ", value: "subGrupo" },
      { text: "Marca ", value: "marca" },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("grupoProduto", ["gruposProduto", "subGruposProduto"]),
    ...mapState("marca", ["marcas"]),
    ...mapState("unidadeMedida", ["unidadesMedida"]),
    ...mapState("produto", ["produtos"]),
    ...mapState("departamento", ["departamentos"]),
    filteredMarca() {
      return this.marcas.filter((m) => {
        return m.ativo === true;
      });
    },
    filteredUndMedia() {
      return this.unidadesMedida.filter((u) => {
        return u.ativo === true;
      });
    },
    filteredGrupo() {
      return this.gruposProduto.filter((g) => {
        return g.ativo === true;
      });
    },
    filteredSubGrupo() {
      return this.subGruposProduto.filter((s) => {
        return s.ativo === true;
      });
    },
    filteredProduto() {
      return this.produtos.filter((p) => {
        return p.ativo === true;
      });
    },
  },
  methods: {
    ...mapActions("produto", [
      "atualizarProdutos",
      "atualizarProduto",
      "addProduto",
    ]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;

        if (
          this.possuiConversao &&
          (this.conversoes == null || this.conversoes.length == 0)
        ) {
          this.$alert("É necessário ter conversões adicionadas", "", "error");
          return;
        }
        var img = this.$refs.avatar.getImg();
        const resposta = await enviarProdutoAsync(
          //parseInt(this.$refs.formulario.tipo),
          this.$refs.formulario.tipos,
          this.$refs.formulario.descricao,
          this.$refs.formulario.codigo,
          this.$refs.formulario.grupoSelected.id,
          this.$refs.formulario.subGrupoSelected.id,
          this.$refs.formulario.marcaSelected.id,
          this.$refs.formulario.unidadeMedidaSelected.id,
          this.$refs.formulario.departamentoSelected.id,
          this.possuiConversao,
          img,
          this.conversoes
        );
        if (resposta == 0) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          //this.$alert(resposta.message, "Descupe, falha na operação!", "error");
          this.$alert("", "Descupe, falha na operação!", "error");
        } else {
          this.addProduto(this.mountObjProduto(resposta));
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/produto&servico");
        }
      }
    },
    remove(index) {
      this.conversoes = this.conversoes.filter((c) => c.id != index);
    },
    obterIdProdutoSalvo(produtoSalvo) {
      if (produtoSalvo && typeof produtoSalvo === "object") {
        return produtoSalvo.id || produtoSalvo.Id;
      }

      return produtoSalvo;
    },
    mountObjProduto(produtoSalvo) {
      var produto = new Object();
      produto.id = this.obterIdProdutoSalvo(produtoSalvo);
      //produto.tipo = this.$refs.formulario.tipo;
      produto.tipos = this.$refs.formulario.tipos;
      produto.descricao = this.$refs.formulario.descricao;
      produto.codigo = this.$refs.formulario.codigo;
      produto.idGrupo = this.$refs.formulario.grupoSelected.id;
      produto.idSubGrupo = this.$refs.formulario.subGrupoSelected.id;
      produto.idMarca = this.$refs.formulario.marcaSelected.id;
      produto.idUnidadeMedida = this.$refs.formulario.unidadeMedidaSelected.id;
      produto.unidadeMedida =
        this.$refs.formulario.unidadeMedidaSelected.descricao;
      produto.grupo = this.$refs.formulario.grupoSelected.descricao;
      produto.subGrupo = this.$refs.formulario.subGrupoSelected.descricao;
      produto.marca = this.$refs.formulario.marcaSelected.descricao;
      produto.idDepartamento = this.$refs.formulario.departamentoSelected.id;
      produto.departamento = this.$refs.formulario.departamentoSelected.descricao;
      produto.imagem = this.$refs.avatar.getImg();
      produto.ativo = true;
      produto.conversoes = this.conversoes;
      return produto;
    },
    mountObjProdutoFromModal(produtoSalvo) {
      var produto = new Object();
      produto.id = this.obterIdProdutoSalvo(produtoSalvo);
      //produto.tipo = this.$refs.frmAdd.tipo;
      produto.tipos = this.$refs.frmAdd.tipos;
      produto.descricao = this.$refs.frmAdd.descricao;
      produto.codigo = this.$refs.frmAdd.codigo;
      produto.idGrupo = this.$refs.frmAdd.grupoSelected.id;
      produto.idSubGrupo = this.$refs.frmAdd.subGrupoSelected.id;
      produto.idMarca = this.$refs.frmAdd.marcaSelected.id;
      produto.idUnidadeMedida = this.$refs.frmAdd.unidadeMedidaSelected.id;
      produto.unidadeMedida = this.$refs.frmAdd.unidadeMedidaSelected.descricao;
      produto.grupo = this.$refs.frmAdd.grupoSelected.descricao;
      produto.subGrupo = this.$refs.frmAdd.subGrupoSelected.descricao;
      produto.marca = this.$refs.frmAdd.marcaSelected.descricao;
      produto.idDepartamento = this.$refs.frmAdd.departamentoSelected.id;
      produto.departamento = this.$refs.frmAdd.departamentoSelected.descricao;
      produto.imagem = this.$refs.avatarFrmAdd.getImg();
      produto.ativo = true;
      produto.conversoes = null;
      return produto;
    },
    addLista() {
      this.showModal = true;
    },
    async enviarFrmAdd() {
      if (this.$refs.form2.validate()) {
        var img = this.$refs.avatarFrmAdd.getImg();
        const resposta = await enviarProdutoAsync(
          //parseInt(this.$refs.frmAdd.tipo),
          this.$refs.frmAdd.tipos,
          this.$refs.frmAdd.descricao,
          this.$refs.frmAdd.codigo,
          this.$refs.frmAdd.grupoSelected.id,
          this.$refs.frmAdd.subGrupoSelected.id,
          this.$refs.frmAdd.marcaSelected.id,
          this.$refs.frmAdd.unidadeMedidaSelected.id,
          this.$refs.frmAdd.departamentoSelected.id,
          false,
          img,
          null
        );
        if (resposta == 0) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.showModal = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error").then(() => {
            this.showModal = true;
          });
        } else {
          this.addProduto(this.mountObjProdutoFromModal(resposta));
          //this.atualizarProdutos();
          this.showModal = false;
          this.$refs.form2.reset();
        }
      }
    },
  },
  components: {
    TabNavegacaoProduto,
    Avatar,
    Formulario,
  },
};
</script>
